// extracted by mini-css-extract-plugin
module.exports = {"spinner":"LoadingWithText_spinner__wYnv5","spinnerText":"LoadingWithText_spinnerText__RzxIv","loading":"LoadingWithText_loading__A8LMU"};